import React from 'react'

import Layout from '../layouts/layout'
import { HeroTos, PlainText } from '../components'
import tosData from '../components/includes/PlainText/tos-data'

const TosPage = () => (
  <Layout>
    <HeroTos
      title='Terms of service'
      text='This following page acts as a contract between you and Pixel2HTML, collectively referred to as the "parties", by submitting your project with Pixel2HTML you agree to this terms.'
      subtitle='Welcome to the Pixel2HTML website/service which is operated by Pixel2HTML dBA Nerdev LLC (in this Agreement, "Pixe2HTML", "Pixel, "we", "us" or "our").<br/><br/>This following page acts as a contract between you and Pixel2HTML, collectively referred to as the "parties".<br/><br/>By accessing, browsing, and using the Site and its services (“Services”), you accept, without limitation or qualification, these Terms and Conditions. If you do not wish to be bound by these Terms and Conditions, you should not access the Site or use its Services. By using the Services or the Site, you represent and warrant that you are 13 (thirteen) years of age or older and that you accept and agree to abide by all of the terms and conditions of this Agreement. The Site may, without notice to the User, add additional features or change or eliminate features or Services, change nomenclature, and make other changes at any time, which will be subject to these Terms and Conditions.'
    />
    <PlainText data={tosData} date="July 19th, 2017"/>
  </Layout>
)

export default TosPage
